import { shouldForwardProp } from '@mui/system';
import { Card, IconButton, styled } from '../../../../base';

export const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '340px',
    maxHeight: '340px',
    width: '400px',
    maxWidth: '100%',
    padding: theme.spacing(2),
}));

export const CardActions = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    marginTop: 'auto',
}));

export const JobInfo = styled('div')(({ theme }) => ({
    gap: theme.spacing(2),
    margin: theme.spacing(1, 0),
    justifyContent: 'space-between',
    marginTop: 'auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    width: '100%',
}));

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['borderColor', 'iconColor'].includes(prop as string);

export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: customShouldForwardProp,
})<{ borderColor: string }>(({ theme, borderColor }) => ({
    border: '2px solid',
    borderColor: borderColor,
    marginInlineEnd: theme.spacing(1),
    height: '46px',
    width: '46px',

    '&:hover': {
        backgroundColor: theme.palette.background.mainBackground, // Background color on hover
        borderColor: borderColor,
    },
}));
